module.exports = __webpack_public_path__ + "img/book.e62db27d.svg";